import { h } from 'preact';
export const ArrowRight = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("line", { x1: "5", y1: "12", x2: "19", y2: "12" }),
        h("polyline", { points: "12 5 19 12 12 19" })));
};
//# sourceMappingURL=arrow-right.js.map